<div class="lot-card-swipe-container"
     data-testid="cm-card-lot-swipe-container"
     (touchstart)="onTouchStart($event)"
     (touchmove)="onTouchMove($event)"
     (touchend)="onTouchEnd()">

  <a class="lot-card"
     [class.loading-images]="isLoadingImages"
     [class.swiped]="isSwipedOpen"
     [style.transform]="'translateX(' + swipeOffset + 'px)'"
     data-testid="cm-card-lot"
     [href]="getLotUrl()"
     (click)="OnCardClick($event)">
    <div class="lot-main"
         data-testid="cm-container-lot-main">
      <div class="top-row">
        <div class="primary-display-value"
             data-testid="cm-text-lot-primary-display-value">
          {{ primaryDisplayValue }}
        </div>
        @if(isLoadingImages) {
          <div class="image-hydration-progress">
            <i class="pi pi-cloud-download"></i>
            <span>{{overallImageProgress}}%</span>
          </div>
        }
      </div>

      <div class="lot-detail-row"
           data-testid="cm-container-lot-detail">
        @if (!isAddressPrimary) {
          <i class="pi pi-map-marker"></i>
        }
        <span class="secondary-display-value"
              data-testid="cm-text-lot-secondary-display-value">{{ secondaryDisplayValue }}</span>
      </div>

    </div>

    <div class="lot-chevron"
         data-testid="cm-icon-lot-chevron">
      <i class="pi pi-chevron-right"></i>
    </div>
  </a>

  @if(isLoadingImages === false) {
    <button class="swipe-archive-btn"
            type="button"
            aria-label="Archive lot"
            data-testid="cm-btn-lot-archive"
            (click)="onArchiveClick($event)">
      <i class="pi pi-inbox"></i>
      <span>Archive</span>
    </button>
  }
</div>